import React from 'react'
import { Route, Link } from 'react-router'
import { connect } from 'react-redux'
import { setUsername } from '../actions/users'
import {
  toggleSidebar, setGameList, openChallengeModal, closeChallengeModal,
  openViewChallengeModal, closeViewChallengeModal, openAlertModal,
  closeAlertModal, openViewRequestModal, closeViewRequestModal,
  setFriendList,
} from '../actions/layout'
import Header from '../components/Header/Header'
import Sidebar from '../components/Sidebar'
import Alert from '../components/Alert/Alert'
import SidebarClasses from '../components/Sidebar.scss'
import classes from './CoreLayout.scss'

class CoreLayout extends React.Component {

  constructor (props) {
    super(props)
    const { setUsername } = props

    const baseUrl = process.env.NODE_ENV === 'production' ? 'https://api.mrjotto.com' : 'http://localhost:3000'
    this.state = { baseUrl }
    // load the user
    fetch(`${baseUrl}/user/info`, { credentials: 'include' })
      .then(res => res.json())
      .then(res => {
        if (res.result === 'ok') {
          setUsername(res.msg)
        }
      })

    const self: any = this
    self.toggleSidebar = self.toggleSidebar.bind(self)
  }

  toggleSidebar () {
    const { sidebar, toggleSidebar } = this.props
    toggleSidebar(!sidebar)
  }

  render () {
    const { baseUrl } = this.state
    const {
      sidebar, children, toggleSidebar, username, gameList, setGameList, setUsername,
      challengeModal, openChallengeModal, closeChallengeModal, openViewChallengeModal,
      closeViewChallengeModal, viewChallengeModal, alertModal, openAlertModal,
      closeAlertModal, viewRequestModal, openViewRequestModal, closeViewRequestModal,
      friendList,
      } = this.props
    const sidebarClasses = sidebar && SidebarClasses.visible
    return (
      <div className={classes.main}>
        <Header toggleSidebar={this.toggleSidebar} />
        {alertModal && <Alert message={alertModal} closeAlertModal={closeAlertModal} />}
        <div style={{textAlign: 'center', marginTop: '50px'}}>
          {React.cloneElement(children, {
            baseUrl,
            username,
            sidebar,
            setUsername,
            toggleSidebar,
            setGameList,
            gameList,
            challengeModal,
            openChallengeModal,
            closeChallengeModal,
            viewChallengeModal,
            openViewChallengeModal,
            closeViewChallengeModal,
            alertModal,
            openAlertModal,
            closeAlertModal,
            viewRequestModal,
            openViewRequestModal,
            closeViewRequestModal,
            friendList,
            setFriendList,
          })}
        </div>
        <Sidebar className={sidebarClasses} baseUrl={baseUrl} setUsername={setUsername} toggleSidebar={toggleSidebar} />
      </div>
    )
  }
}

export const mapStateToProps = (state: any, ownProps: any): any => {
  return {
    username: state.username,
    sidebar: state.sidebar,
    gameList: state.gameList,
    challengeModal: state.challengeModal,
    viewChallengeModal: state.viewChallengeModal,
    viewRequestModal: state.viewRequestModal,
    alertModal: state.alertModal,
    friendList: state.friendList,
  }
}

export const mapDispatchToProps = (dispatch: Function, ownProps: any): any => {
  return {
    setUsername: (username) => dispatch(setUsername(username)),
    setGameList: (view) => dispatch(setGameList(view)),
    toggleSidebar: (enabled) => dispatch(toggleSidebar(enabled)),
    openChallengeModal: () => dispatch(openChallengeModal()),
    closeChallengeModal: () => dispatch(closeChallengeModal()),
    openViewChallengeModal: (id) => dispatch(openViewChallengeModal(id)),
    closeViewChallengeModal: () => dispatch(closeViewChallengeModal()),
    openAlertModal: (msg) => dispatch(openAlertModal(msg)),
    closeAlertModal: () => dispatch(closeAlertModal()),
    openViewRequestModal: (id) => dispatch(openViewRequestModal(id)),
    closeViewRequestModal: () => dispatch(closeViewRequestModal()),
    setFriendList: (list) => dispatch(setFriendList(list)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CoreLayout)



/** WEBPACK FOOTER **
 ** ./src/containers/CoreLayout.js
 **/